module.exports = __webpack_public_path__ + "img/MaryCarmen_Lopez.1f0be9ab.webp";